import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';
import global_es from './translations/es/global.json';
import global_en from './translations/en/global.json';
import dashboard_es from './translations/es/dashboard.json';
import dashboard_en from './translations/en/dashboard.json';
import account_es from './translations/es/account.json';
import account_en from './translations/en/account.json';
import analytics_es from './translations/es/analytics.json';
import analytics_en from './translations/en/analytics.json';
import finance_es from './translations/es/finance.json';
import sidebar_es from './translations/es/sidebar.json';
import sidebar_en from './translations/en/sidebar.json';
import navbar_es from './translations/es/navbar.json';
import navbar_en from './translations/en/navbar.json';
import users_es from './translations/es/users.json';
import users_en from './translations/en/users.json';
import transactions_es from './translations/es/transactions.json';
import transactions_en from './translations/en/transactions.json';
import contracts_es from './translations/es/contracts.json';
import contracts_en from './translations/en/contracts.json';
import glossary_es from './translations/es/glossary.json';
import glossary_en from './translations/en/glossary.json';

const resources = {
  en: {
    global: global_en,
    dashboard: dashboard_en,
    account: account_en,
    navbar: navbar_en,
    sidebar: sidebar_en,
    users: users_en,
    transactions: transactions_en,
    analytics: analytics_en,
    contracts: contracts_en,
    glossary: glossary_en
  },
  es: {
    global: global_es,
    dashboard: dashboard_es,
    account: account_es,
    analytics: analytics_es,
    finance: finance_es,
    sidebar: sidebar_es,
    navbar: navbar_es,
    users: users_es,
    transaction: transactions_es,
    contracts: contracts_es,
    glossary: glossary_es
  }
};

// Check for a language cookie, or default to 'es' if not set
const defaultLanguage = Cookies.get('language') || 'es';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });
